function getDomOfNode(node) {
  var dom = document.querySelector(`.${node.id}`)
  return dom
}
export function ratioOfRemToPixel() {
  return parseInt(getComputedStyle(document.documentElement).fontSize)
}

export function pixelToRem(pxValue) {
  return pxValue / ratioOfRemToPixel()
}

export function remToPixel(remValue) {
  return remValue * ratioOfRemToPixel()
}

export function getMetaComponentElementDom(node, metaComponnet) {
  var dom = getDomOfNode(node)
  if (metaComponnet.element === 'self') {
    return dom
  } else {
    return dom.querySelector(`.${metaComponnet.element}`)
  }
}

export function getFontSizeOfMetaComponentElelemntDom(node, metaComponnet) {
  var dom = getMetaComponentElementDom(node, metaComponnet)
  var fontSize = parseInt(getComputedStyle(dom).fontSize)
  return fontSize
}

export function getParentWidthOfMetaComponentElelemntDom(node, metaComponnet) {
  var dom = getMetaComponentElementDom(node, metaComponnet)
  var width = parseInt(getComputedStyle(dom.parentElement).width)
  return width
}

export function getWidthOrFontSizeInPercentCircumstance(node, metaComponnet) {
  if (
    metaComponnet.componentType === 'lineHeight' ||
    metaComponnet.componentType === 'letterSpace' ||
    metaComponnet.componentType === 'borderRadius'
  ) {
    return getFontSizeOfMetaComponentElelemntDom(node, metaComponnet)
  } else {
    return getParentWidthOfMetaComponentElelemntDom(node, metaComponnet)
  }
}

export function ratioOfPercentToPixel(node, metaComponnet) {
  return getWidthOrFontSizeInPercentCircumstance(node, metaComponnet) / 100
}

export function pixelToPercent(pxValue, node, metaComponnet) {
  var ratio = ratioOfPercentToPixel(node, metaComponnet)
  return pxValue / ratio
}

export function percentToPixel(percentValue, node, metaComponnet) {
  return percentValue * ratioOfPercentToPixel(node, metaComponnet)
}

export function unitTransform(oldUnit, unit, key, value, node, metaComponnet) {
  var res
  if(value === 'auto'){
    res = value
  }else{
    if (oldUnit === 'px' && unit === 'rem') {
      res = pixelToRem(value)
    } else if (oldUnit === 'rem' && unit === 'px') {
      res = remToPixel(value)
    } else if (oldUnit === 'px' && unit === '%') {
      res = pixelToPercent(value, node, metaComponnet)
    } else if (oldUnit === '%' && unit === 'px') {
      res = percentToPixel(value, node, metaComponnet)
    } else if (oldUnit === 'rem' && unit === '%') {
      res = pixelToPercent(remToPixel(value), node, metaComponnet)
    } else if (oldUnit === '%' && unit === 'rem') {
      res = pixelToRem(percentToPixel(value, node, metaComponnet))
    }else{
      res = value
    }

    window.stopSynchronousThreeEnd = true
    setTimeout(() => {
      window.stopSynchronousThreeEnd = false
    }, 30)
  }

  key.value = res
}

export function getOtherUnitValueFromPixel(unit, pxValue, node, metaComponent) {
  if (unit === 'rem') {
    return pixelToRem(pxValue)
  } else if (unit === '%') {
    return pixelToPercent(pxValue, node, metaComponent)
  } else {
    return Number(pxValue)
  }
}

export function getPixelValueFromOtherUnit(unit, value, node, metaComponent) {
  if(typeof value === 'string' && value.startsWith('var(')){
    var rootVarName = value.replace('var(','').replace(')','')
    value = getComputedStyle(document.querySelector(':root')).getPropertyValue(rootVarName)
  }




  if (unit === 'rem') {
    return remToPixel(value)
  } else if (unit === '%') {
    return percentToPixel(value, node, metaComponent)
  } else {
    return Number(value)
  }
}

export function unitTransformSimplify(oldUnit, newUnit, oldValue, node, metaComponnet) {
  var value
  if (oldUnit == 'px') {
    switch (newUnit) {
      case 'rem':
        value = pixelToRem(Number(oldValue))
        break
      case '%':
        value = pixelToPercent(Number(oldValue), node, metaComponnet)
        break
      case 'px':
        value = oldValue
        break
    }
  }
  return value
}
